/**
反算工具类
ver 1.0.0
修改记录：
  2021-11-8：
    safeGoodsBackCountUtil.
    用于商品安全库存设置药械闪加后 修改上下限（辅助单位） 然后根据换算比例来计算上下限
*/
import calculateUtils from './calculateUtil'
let safeGoodsBackCountUtil = {}

/**
 * 商品库存的下限数量 通过换算比例由商品下限的辅助数量 来计算库存的下限数量
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 *
 */

safeGoodsBackCountUtil.lowDisplay = (data, formData, decimal = 6) => {
  data.low = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.lowDisplay, data.ratio.dividend, 0),
    data.ratio.divisor,
    decimal
  )
}

/**
 * 商品库存的上限数量 通过换算比例由商品上限的辅助数量 来计算库存的上限数量
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 *
 */
safeGoodsBackCountUtil.topDisplay = (data, formData, decimal = 6) => {
  data.top = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.topDisplay, data.ratio.dividend, 0),
    data.ratio.divisor,
    decimal
  )
}

/**
 * 商品库存的安全库存的数量 通过换算比例由商品安全库存的辅助数量 来计算库存的安全库存数量
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 *
 */
safeGoodsBackCountUtil.safeDisplay = (data, formData, decimal = 6) => {
  data.safe = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.safeDisplay, data.ratio.dividend, 0),
    data.ratio.divisor,
    decimal
  )
}

/**
 * 商品的辅助单位 辅助单位更新之后要更新所有的数据
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 *
 */
safeGoodsBackCountUtil.unitDisplayForm = (data, formData, decimal = 6) => {
  if (data.unitDisplayForm && data.unitDisplayForm.ratio) {
    data.ratio = data.unitDisplayForm.ratio
  }
  if (!data.ratio)
    data.ratio = {
      divisor: 1,
      dividend: 1,
    }
  if (!data.ratio.divisor) data.ratio.divisor = 1
  if (!data.ratio.dividend) data.ratio.dividend = 1

  safeGoodsBackCountUtil.lowDisplay(data, formData, decimal)
  safeGoodsBackCountUtil.topDisplay(data, formData, decimal)
  safeGoodsBackCountUtil.safeDisplay(data, formData, decimal)
}

export default safeGoodsBackCountUtil
